(ns pfo.controller
  (:require [reagent.core :as reagent :refer [atom]]
            [keechma.next.core :as core]
            [pfo.bulk.controller]
            [pfo.collection.controller]
            [pfo.coltype.controller]
            [pfo.link.controller]
            [pfo.admin.controller]
            [pfo.label.controller]
            [pfo.signature.controller]
            [pfo.task.controller]
            [pfo.document.controller]
            [pfo.chat.controller]
            [pfo.staging.controller]
            [pfo.im.controller]
            [keechma.next.controller :as ctrl]))

(defn controllers [& refs]
  {:keechma/controllers (into {} (map (fn [aref] [aref {:keechma.controller/params true}]) refs))})

(def app (apply controllers (descendants :keechma/controller)))

;; (def app
;;   {:keechma/controllers {:permitted-groups {:keechma.controller/params true}
;;                          :bulk-operations {:keechma.controller/params true}
;;                          :bulk-apply-items {:keechma.controller/params true}
;;                          :child-links {:keechma.controller/params true}
;;                          :template-users {:keechma.controller/params true}}})
;;

(def app-instance (core/start! app))

(defn dispatch [akey & args] (apply core/dispatch app-instance akey args))

(defn subscribe [akey]
  (let [value-atom (atom ((core/get-derived-state app-instance) akey))]
    (core/subscribe app-instance akey (fn [state] (reset! value-atom state)))
    value-atom))
